import React from 'react';
const RelatedLinks = () => {
  const relatedLinks = [
    {
      title: 'Calculate Your Age',
      url: '/calculator/en/agegregorian/',
    },
    {
      title: 'Calculate If Your Weight Is Suitable for Your Height',
      url: '/calculator/en/bmiadults/',
    },
    {
      title: 'Period Calculator',
      url: '/calculator/en/period/',
    },
    {
      title: 'Calculate If You Are Obliged to Pay Zakat',
      url: '/calculator/en/money-zakat/',
    },
  ];
  return (
    <div>
      <b>Related Calculators:</b>
      <div className="related-links-container">
        {relatedLinks.map((link, index) => (
          <React.Fragment key={index}>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary btn-sm "
            >
              {link.title}
            </a>  <span style={{marginRight:'15px'}}></span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
export default RelatedLinks;
